import React, { FC, PropsWithChildren, useContext } from "react";
import styled from "styled-components";
import { FilterItem } from "./FilterItem";
// Importing the interface for the props (Main Filter Component)
import { AppContext } from "./AppContext";
import XIcon from "./Icons/XIcon";
// Importing the filters component
import FilterForm from "./FilterForm";

const Card = styled.div<{ isOpen: boolean; top: number }>`
  position: absolute;
  z-index: 2;
  top: ${(props) => `calc(${props.top || 300}px - 135px)`};
  left: ${(props) => (props.isOpen ? "23rem" : "2rem")};
  overflow: hidden;
  display: flex;
  flex-flow: column;
  transition: 0.3s;
`;

const CardWrapper = styled.div`
  display: flex;
  flex-flow: column;
  flex-grow: 1;
  flex-shrink: 1;
  border-top-right-radius: 1.6rem;
  border-bottom-right-radius: 1.6rem;
  width: 20rem;
  box-shadow: 0 1px 7px 0 rgb(0 0 0 / 20%);
  position: relative;
  overflow: hidden;
  background: white;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const HeaderWrapper = styled.div`
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #c0bebe;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const Header = styled.h4`
  margin: 0;
  font-weight: 800;
  font-size: 18px;
  letter-spacing: -0.5px;
  color: #522398;
`;

const CardContentWrapper = styled.div`
  padding: 1rem;
  flex-grow: 1;
  flex-shrink: 1;
  display: flex;
  flex-direction: column;
  ::-webkit-scrollbar {
    border-radius: 30px;
  }
`;

interface IFilterTemplate {
  top: number;
  isOpen: boolean;
  close: () => void;
  label?: string;
  filters: { value: string; label: string }[];
  activeFilters: string[];
  handleFormChange: (event: InputEvent) => void;
  isMobile?: boolean;
  type?: string;
}

export const FilterTemplate: FC<PropsWithChildren<IFilterTemplate>> = ({
  top,
  isOpen,
  close,
  label,
  filters,
  activeFilters,
  handleFormChange,
  type,
}) => {
  const {
    productFiltersGlobal,
    setProductFiltersGlobal,
    setShowBusinessFilters,
    setShowProductFilters,
    showBusinessFilters,
    businessFiltersGlobal,
    setBusinessFiltersGlobal,
  } = useContext(AppContext);

  return (
    <Card isOpen={isOpen} top={top}>
      <CardWrapper>
        <HeaderWrapper>
          <Header>{label}</Header>
          <XIcon onClick={close} />
        </HeaderWrapper>
        <CardContentWrapper>
          <FilterForm>
            {filters.map(({ value, label }, index) => {
              const isInGlobal = activeFilters.includes(value);
              return (
                <FilterItem
                  key={index}
                  keyName={index}
                  checked={isInGlobal}
                  type={"radio"}
                  gridColumnStyle={"1fr"}
                  onClick={handleFormChange}
                  filterType={type}
                  value={value}
                  label={label}
                />
              );
            })}
          </FilterForm>
        </CardContentWrapper>
      </CardWrapper>
    </Card>
  );
};
